import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';

export default function NightSessionFAB() {
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    const onScroll = () => {
      setVisible(window.scrollY > window.innerHeight * 0.8);
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const show = visible && !dismissed;

  return (
    <div
      aria-hidden={!show}
      className={`fixed bottom-24 right-5 z-40 flex flex-col items-end gap-1.5 transition-all duration-500 ease-out ${
        show
          ? 'opacity-100 translate-y-0 pointer-events-auto'
          : 'opacity-0 translate-y-8 pointer-events-none'
      }`}
    >
      {/* Floating stars around the button */}
      <div className="relative">
        <div
          className="star-twinkle absolute -top-2 -left-2 w-1.5 h-1.5 rounded-full pointer-events-none"
          style={{ backgroundColor: 'rgba(245,158,11,0.85)', animationDelay: '0s' }}
        />
        <div
          className="star-twinkle-slow absolute -top-3 left-8 w-1 h-1 rounded-full bg-white pointer-events-none"
          style={{ animationDelay: '1.1s' }}
        />
        <div
          className="star-twinkle-fast absolute top-1 -right-3 w-1 h-1 rounded-full bg-white pointer-events-none"
          style={{ animationDelay: '0.5s' }}
        />
        <div
          className="star-twinkle absolute -bottom-2 left-4 w-1.5 h-1.5 rounded-full pointer-events-none"
          style={{ backgroundColor: 'rgba(245,158,11,0.7)', animationDelay: '1.8s' }}
        />

        {/* Main pill button */}
        <div
          className="flex items-center rounded-full overflow-hidden"
          style={{
            background: 'linear-gradient(135deg, #020818 0%, #0F172A 50%, #1a1040 100%)',
            border: '1px solid rgba(245,158,11,0.45)',
            boxShadow: '0 0 18px 2px rgba(245,158,11,0.15), 0 8px 28px -6px rgba(2,8,24,0.6)',
          }}
        >
          <Link
            to="/enroll"
            className="whitespace-nowrap flex items-center gap-2.5 pl-3 pr-4 py-2.5 cursor-pointer group"
          >
            {/* Moon icon in gold circle */}
            <div className="w-7 h-7 flex items-center justify-center rounded-full bg-brand-yellow flex-shrink-0 group-hover:scale-110 transition-transform duration-200">
              <i className="ri-moon-fill text-[#0F172A] text-sm" />
            </div>

            {/* Label */}
            <span className="font-body font-bold text-sm text-white group-hover:text-brand-yellow transition-colors duration-200">
              Book Night Session
            </span>

            {/* Arrow */}
            <i className="ri-arrow-right-line text-brand-yellow/70 text-sm group-hover:translate-x-0.5 transition-transform duration-200" />
          </Link>

          {/* Dismiss divider + X */}
          <div className="h-full w-px bg-white/10" />
          <button
            onClick={() => setDismissed(true)}
            className="whitespace-nowrap w-9 h-full flex items-center justify-center text-white/40 hover:text-white/80 transition-colors duration-200 cursor-pointer pr-1"
            aria-label="Dismiss"
          >
            <i className="ri-close-line text-sm" />
          </button>
        </div>

        {/* Subtle glow pulse ring */}
        <div
          className="absolute inset-0 rounded-full pointer-events-none"
          style={{
            animation: 'nightFABGlow 3s ease-in-out infinite',
          }}
        />
      </div>

      {/* "Open until 9pm" micro-label */}
      <span
        className="font-body text-[10px] font-semibold tracking-wider uppercase text-amber-400/70 pr-1"
        style={{ textShadow: '0 0 12px rgba(245,158,11,0.4)' }}
      >
        Open until 9pm · Mon–Sat
      </span>

      <style>{`
        @keyframes nightFABGlow {
          0%, 100% { box-shadow: 0 0 0 0 rgba(245,158,11,0); }
          50%       { box-shadow: 0 0 0 5px rgba(245,158,11,0.12); }
        }
      `}</style>
    </div>
  );
}
